var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editor-canvas-view",
      class: _vm.computedClasses,
      style: _vm.computedStyles,
    },
    [
      _vm.showEditorOfferingFrame
        ? _c("div", { staticClass: "editor-canvas-view-offering-frame" }, [
            _c("img", {
              attrs: {
                crossOrigin: "anonymous",
                src: _vm.offeringFrameModel.url + "?noCorsHeader",
                height: _vm.offeringFrameHeight,
                width: _vm.offeringFrameWidth,
              },
            }),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "editor-canvas-view-draw-views-container",
          style: _vm.drawViewsContainerStyles,
        },
        [
          _c("EditorDrawView", {
            staticClass: "editor-draw-background-view",
            attrs: {
              "bleed-margin": _vm.bleedMargin,
              "is-canvas-overlay-active": _vm.isTextOverlayActive,
              "draw-mask": true,
              "draw-page": true,
              height: _vm.pageModel.height,
              "offering-frame-model": _vm.offeringFrameModel,
              "offering-model": _vm.offeringModel,
              "page-model": _vm.pageModel,
              scaling: _vm.computedScaling,
              "show-editor-offering-frame": _vm.showEditorOfferingFrame,
              width: _vm.pageModel.width,
            },
            on: {
              "draw-objects-change": _vm.onDrawObjectsChange,
              "page-model-change": _vm.onPageModelChange,
            },
          }),
          _vm.isInteractive
            ? _c("EditorInteractiveView", {
                ref: "interactiveView",
                attrs: {
                  "bleed-margin": _vm.bleedMargin,
                  canvas: _vm.canvasElement,
                  height: _vm.pageModel.height,
                  "is-eye-dropper-shown": _vm.internalIsEyeDropperShown,
                  "is-photo-object-transformable":
                    _vm.isPhotoObjectTransformable,
                  "multiple-text-support": _vm.multipleTextSupport,
                  "offering-model": _vm.offeringModel,
                  "page-model": _vm.pageModel,
                  "page-objects": _vm.internalPageObjects,
                  "page-template-positions-available":
                    _vm.pageTemplatePositionsAvailable,
                  "product-type": _vm.offeringModel.type,
                  scaling: _vm.computedScaling,
                  "selected-object-border-color": _vm.selectedObjectBorderColor,
                  "text-color": _vm.inverseBackgroundColor,
                  "text-options-anchor": _vm.objectActionsAnchor,
                  width: _vm.pageModel.width,
                },
                on: {
                  "add-photo": _vm.onAddPhoto,
                  "add-text": _vm.onAddText,
                  change: _vm.onEditorInteractiveChange,
                  "delete-object": _vm.onEditorInteractiveDeleteObject,
                  "eye-dropper-shown-change":
                    _vm.onEditorInteractiveEyeDropperShownChange,
                  "push-changes": _vm.onEditorInteractivePushChanges,
                },
              })
            : _vm._e(),
          _vm._l(_vm.internalPageObjectsOrdered, function (pageObject) {
            return _c("EditorDrawView", {
              key: pageObject.id,
              staticClass: "editor-draw-page-object-view",
              attrs: {
                "bleed-margin": _vm.bleedMargin,
                "is-canvas-overlay-active":
                  _vm.isTextOverlayActive && _vm.isPhotoObject(pageObject),
                color: _vm.inverseBackgroundColor,
                "draw-mask": true,
                "draw-objects": [pageObject],
                height: _vm.pageModel.height,
                "object-style": _vm.objectStyle(pageObject),
                "offering-frame-model": _vm.offeringFrameModel,
                "offering-model": _vm.offeringModel,
                "page-model": _vm.pageModel,
                scaling: _vm.computedScaling,
                "show-editor-offering-frame": _vm.showEditorOfferingFrame,
                width: _vm.pageModel.width,
              },
              on: { "draw-objects-change": _vm.onDrawObjectsChange },
            })
          }),
          _c("EditorDrawView", {
            ref: "mainCanvas",
            staticClass: "editor-draw-page-objects-view",
            attrs: {
              "bleed-margin": _vm.bleedMargin,
              color: _vm.inverseBackgroundColor,
              "draw-mask": true,
              "draw-objects": _vm.photoObjects,
              "draw-overlay": true,
              "draw-page": true,
              height: _vm.pageModel.height,
              "mirror-overlay": _vm.flippedOverlay,
              "offering-frame-model": _vm.offeringFrameModel,
              "offering-model": _vm.offeringModel,
              "page-model": _vm.pageModel,
              scaling: _vm.computedScaling,
              "show-editor-offering-frame": _vm.showEditorOfferingFrame,
              width: _vm.pageModel.width,
            },
          }),
          _vm.addressModel
            ? _c("EditorDrawView", {
                staticClass: "editor-draw-address-view",
                attrs: {
                  "address-model": _vm.addressModel,
                  "bleed-margin": _vm.bleedMargin,
                  "is-canvas-overlay-active": _vm.isTextOverlayActive,
                  height: _vm.pageModel.height,
                  "offering-frame-model": _vm.offeringFrameModel,
                  "offering-model": _vm.offeringModel,
                  "page-model": _vm.pageModel,
                  scaling: _vm.computedScaling,
                  width: _vm.pageModel.width,
                },
                on: { "draw-objects-change": _vm.onDrawObjectsChange },
              })
            : _vm._e(),
          _vm.showOverlay
            ? _c("EditorDrawView", {
                staticClass: "editor-draw-overlay-view",
                attrs: {
                  "bleed-margin": _vm.bleedMargin,
                  "is-canvas-overlay-active": _vm.isTextOverlayActive,
                  "draw-overlay": true,
                  height: _vm.pageModel.height,
                  "mirror-overlay": _vm.flippedOverlay,
                  "offering-frame-model": _vm.offeringFrameModel,
                  "offering-model": _vm.offeringModel,
                  "page-model": _vm.pageModel,
                  scaling: _vm.computedScaling,
                  "show-editor-offering-frame": _vm.showEditorOfferingFrame,
                  width: _vm.pageModel.width,
                },
                on: { "draw-objects-change": _vm.onDrawObjectsChange },
              })
            : _vm._e(),
          _vm.bleedMargin
            ? _c("div", {
                staticClass: "editor-canvas-view-bleed-margin",
                style: _vm.bleedMarginStyles,
              })
            : _vm._e(),
        ],
        2
      ),
      _vm.isInteractive
        ? _c(
            "div",
            {
              ref: "selectedObjectActions",
              staticClass: "editor-canvas-view-selected-photo-object-actions",
              class: {
                "editor-canvas-view-selected-photo-object-actions-hidden":
                  !_vm.shouldShowSelectedObjectActions,
              },
              style: _vm.selectedObjectActionsStyles,
            },
            [
              _c("IconComponent", { on: { click: _vm.onDeleteObject } }, [
                _vm._v("delete"),
              ]),
              _c("divider", { staticClass: "divider full" }),
              _c("IconComponent", { on: { click: _vm.onEditObject } }, [
                _vm._v("edit"),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }